import { useState, useEffect } from 'react';

export const useScrollHeader = (threshold = 50) => {
    const [isScrolled, setIsScrolled] = useState(false);

    useEffect(() => {
        let rafId: number;

        const handleScroll = () => {
            if (rafId) cancelAnimationFrame(rafId);
            rafId = requestAnimationFrame(() => {
                setIsScrolled(window.scrollY > threshold);
            });
        };

        window.addEventListener('scroll', handleScroll, { passive: true });
        return () => {
            window.removeEventListener('scroll', handleScroll);
            if (rafId) cancelAnimationFrame(rafId);
        };
    }, [threshold]);

    return isScrolled;
};